import React from 'react';
import PropTypes from 'prop-types';
import TableComponent from './TableComponent';

export default class SortableTable extends React.Component {
  static propTypes = {
    tableData: PropTypes.array.isRequired,
    headerTitles: PropTypes.array.isRequired
  }

  static meta = {
    name: 'Sortable Table'
  }

  state = {
    sortOrder: '',
    tableData: '',
    headerTitles: []
  };

  componentWillMount() {
    this.setState({
      sortOrder: 'col1Ascending',
      tableData: this.props.tableData,
      headerTitles: this.props.headerTitles
    });
  }

  componentDidMount(){
    this.handleSortClickA();
  }

  handleClick = colNumber => {
    if (this.state.sortOrder === 'col1Ascending') {
      if (colNumber === 1) {
        this.handleSortClickB();
      }
      if (colNumber === 2) {
        this.handleSortClickC();
      }
    } else if (this.state.sortOrder === 'col1Descending') {
      if (colNumber === 1) {
        this.handleSortClickA();
      }
      if (colNumber === 2) {
        this.handleSortClickC();
      }
    } else if (this.state.sortOrder === 'col2Ascending') {
      if (colNumber === 1) {
        this.handleSortClickA();
      }
      if (colNumber === 2) {
        this.handleSortClickD();
      }
    } else if (this.state.sortOrder === 'col2Descending') {
      if (colNumber === 1) {
        this.handleSortClickA();
      }
      if (colNumber === 2) {
        this.handleSortClickC();
      }
    }
  };

  handleSortClickA = () => {
    const newData = [].concat(this.state.tableData).map((el, i) => {
      return {
        index: i,
        value: el.name.toLowerCase(),
        name: el.name,
        quantity: el.quantity
      };
    });
    newData.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    this.setState({
      tableData: newData,
      sortOrder: 'col1Ascending'
    });
  };

  handleSortClickB = () => {
    const newData = [].concat(this.state.tableData).map((el, i) => {
      return {
        index: i,
        value: el.name.toLowerCase(),
        name: el.name,
        quantity: el.quantity
      };
    });
    newData.sort((a, b) => {
      if (a.value > b.value) {
        return -1;
      }
      if (a.value < b.value) {
        return 1;
      }
      return 0;
    });
    this.setState({
      tableData: newData,
      sortOrder: 'col1Descending'
    });
  };
  handleSortClickC = () => {
    const newData = [].concat(this.state.tableData).map((el, i) => {
      return {
        index: i,
        value: el.name.toLowerCase(),
        name: el.name,
        quantity: el.quantity
      };
    });
    newData.sort((a, b) => {
      if (a.quantity > b.quantity) {
        return 1;
      } else if (a.quantity < b.quantity) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      } else if (a.value < b.value) {
        return -1;
      } else {
        return 0;
      }
    });
    this.setState({
      tableData: newData,
      sortOrder: 'col2Ascending'
    });
  };
  handleSortClickD = () => {
    const newData = [].concat(this.state.tableData).map((el, i) => {
      return {
        index: i,
        value: el.name.toLowerCase(),
        name: el.name,
        quantity: el.quantity
      };
    });
    newData.sort((a, b) => {
      if (a.quantity > b.quantity) {
        return -1;
      } else if (a.quantity < b.quantity) {
        return 1;
      }
      if (a.value > b.value) {
        return 1;
      } else if (a.value < b.value) {
        return -1;
      } else {
        return 0;
      }
    });
    this.setState({
      tableData: newData,
      sortOrder: 'col2Descending'
    });
  };

  render() {
    return (
      <div>
        <TableComponent
          tableData={this.state.tableData}
          headerTitles={this.state.headerTitles}
          sortOrder={this.state.sortOrder}
          handleClick={this.handleClick}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SortableTable/SortableTable.js